export const injectDynamicVerbiage = ({
  string,
  vehicleMakerFormmatted,
  vehicleModelFormmatted,
  vehicleYear,
  subModelFormmatted
}) => string
  .replace(/MAKE/g, vehicleMakerFormmatted)
  .replace(/MODEL/g, vehicleModelFormmatted)
  .replace(/YEAR/g, vehicleYear)
  .replace(/TRIM/g, subModelFormmatted)

export const getCanonicalUrl = ({ canonical }) => canonical
